import { createSlice } from "@reduxjs/toolkit";
export const EmailSlice = createSlice({
  name: "email",
  initialState: {
    isCheckedEmail: false,
    email: "",
    isInValidEmail: null,
  },
  reducers: {
    changeEmail: (state, action) => {
      state.email = action.payload;
    },
    changeIsCheckedEmail: (state, action) => {
      state.isCheckedEmail = action.payload;
    },
    changeIsEmailValid: (state, action) => {
      state.isInValidEmail = action.payload;
    },
  },
});

export const { changeEmail, changeIsCheckedEmail, changeIsEmailValid } =
  EmailSlice.actions;
export default EmailSlice.reducer;
